Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById('property-edit-step-6')) {
        ManageProperties.components.editStep6 = new Vue({
            el: document.getElementById("property-edit-step-6"),
            store,
            data: function () {
                return {
                }
            },
            mixins: [Mixins.submitStep, Mixins.propertyJSON],
            computed: {
            },
            mounted: function () {
            },
            methods: {
            },
            created: function () {
            },
            destroyed: function () {
            }
        });
    }
});